<template>
  <button :class="{
    active: isActive
  }">
    <span>
      <slot />
    </span>
    <div class="icon">
      <svgInfoCircle />
    </div>
  </button>
</template>

<script>
import svgInfoCircle from '@/svg/svgInfoCircle'
export default {
  props: {
    isActive: Boolean,
  },
  components: {
    svgInfoCircle
  }
}
</script>

<style lang="scss" scoped>
button {
  --btn-helper-height: 36px;
  --btn-helper-min-width: 94px;
  --btn-helper-color: var(--info-500);
  --btn-helper-font-size: 14px;
  --btn-helper-font-weight: 700;
  --btn-helper-bg-color: transparent;
  --btn-helper-pad: 12px;
  --btn-helper-border-radius: 8px;
  --btn-helper-margin: 12px;

  height: var(--btn-helper-height);
  min-width: var(--btn-helper-min-width);
  color: var(--btn-helper-color);
  font-size: var(--btn-helper-font-size);
  font-weight: var(--btn-helper-font-weight);
  background-color: var(--btn-helper-bg-color);
  outline: 0;
  border: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;;
  padding: 0 var(--btn-helper-pad);
  border-radius: var(--btn-helper-border-radius);
  cursor: pointer;
  // margin: 0 0 var(--btn-helper-margin);

  &:hover,
  &.active {
    --btn-helper-bg-color: var(--info-100);
  }
  &:active {
    --btn-helper-bg-color: var(--info-200);
  }
}

button .icon {
  margin-left: 10px;
}
</style>